import React, { Component } from 'react'
import moment from 'moment-timezone'
import { withStyles } from '@material-ui/core/styles'
import { DEFAULT_TIMEZONE } from '../constants'

const styles = theme => ({
  date: {
    margin: 40,
    width: 30
  },
  bigText: {
    textAlign: 'center',
    fontSize: '1.7rem'
  },
  littleText: {
    textAlign: 'center'
  }
})


class Date extends Component {
  render () {
    const { date, classes } = this.props
    return (
      <div className={classes.date}>
        <div className={classes.bigText}>{moment.tz(date, DEFAULT_TIMEZONE).format('D')}</div>
        <div className={classes.littleText}>{moment.tz(date, DEFAULT_TIMEZONE).format('ddd')}</div>
      </div>
    )
  }
}

export default withStyles(styles)(Date)



// WEBPACK FOOTER //
// ./src/components/Date.js